import {
    Box,
    Grid,
    InputAdornment,
    TextField,
    Typography
} from "@material-ui/core";
import { MdEmail } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { RiMessage2Fill } from "react-icons/ri";
import React, { useContext, useState } from "react";
import './ContactForm.css';
import emailjs from 'emailjs-com';
import StyleContext from "../../contexts/StyleContext";

export default function Login() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [emailSent, setEmailSent] = useState(false);


    const submit = (e) => {
        e.preventDefault();
        if (name && email && message) {
            const serviceId = 'service_3qpfid9';
            const templateId = 'template_rjgg6ov';
            const userId = 'user_fU6XptlMrUiVyXLFp9xLx';
            const templateParams = {
                name,
                email,
                message
            };

            emailjs.send(serviceId, templateId, templateParams, userId)
                .then(response => console.log(response))
                .then(error => console.log(error));

            setName('');
            setEmail('');
            setMessage('');
            setEmailSent(true);
        } else {
            alert('Please fill in all fields.');
        }
    };
    console.log(emailSent);
    // const isValidEmail = email => {
    //     const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     return regex.test(String(email).toLowerCase());
    // };
    const { isDark } = useContext(StyleContext);

    return (
        <Box style={{ margin: '20px 8px', }} >
            <div className="login-container1" >
                <Grid container style={{ justifyContent: 'center' }} >
                    <Grid item sm={12} md={6} className="form-box1" >
                        <Typography variant="h4" className="heading1" style={{ textAlign: 'center', color: isDark && '#fff' }}>
                            GET IN TOUCH
                        </Typography>
                        <Typography variant="h6" className="heading1" style={{ textAlign: 'center', color: isDark && '#fff' }}>
                            I'd love to hear from you!
                        </Typography>
                        <div className="divider1" />

                        <form onSubmit={submit}>
                            <TextField
                                InputLabelProps={{
                                    style: { color: isDark && '#fff' },
                                }}
                                value={name} onChange={e => setName(e.target.value)}
                                required
                                className="inputFields1"
                                label="Name"
                                multiline
                                rows={1}
                                InputProps={{

                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <FaUserAlt style={{ color: isDark && '#fff' }} />
                                        </InputAdornment>
                                    )
                                }}
                                style={{ marginTop: 20, color: isDark && '#fff', }}
                            />
                            <TextField
                                InputLabelProps={{
                                    style: { color: isDark && '#fff' },
                                }}
                                value={email} onChange={e => setEmail(e.target.value)}
                                required
                                type="email"
                                className="inputFields1"
                                label="Email address"
                                multiline
                                rows={1}
                                InputProps={{
                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <MdEmail style={{ color: isDark && '#fff' }} />
                                        </InputAdornment>
                                    )
                                }}
                                style={{ marginTop: 20, color: isDark && '#fff' }}
                            />
                            <TextField
                                InputLabelProps={{
                                    style: { color: isDark && '#fff' },
                                }}
                                value={message} onChange={e => setMessage(e.target.value)}
                                required
                                className="inputFields1"
                                id="standard-multiline-static"
                                label="Message"
                                multiline
                                rows={4}
                                InputProps={{
                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <RiMessage2Fill style={{ color: isDark && '#fff' }} />
                                        </InputAdornment>
                                    )
                                }}
                                style={{ marginTop: 20, color: isDark && '#fff' }}
                            />
                            <button className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                            } type="submit" style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }} value="Send" >Send</button>
                        </form>
                        {/* <Box style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }} onClick={submit2} type="submit">
                            <Button text="Send" />
                        </Box> */}
                    </Grid>
                </Grid>
            </div>
        </Box>
    );
}





// import React, { useState } from 'react';
// import emailjs from 'emailjs-com';
// import './ContactForm.css';
// import Button from '../button/Button';

// const ContactForm = () => {
//     const [name, setName] = useState('');
//     const [email, setEmail] = useState('');
//     const [message, setMessage] = useState('');
//     const [emailSent, setEmailSent] = useState(false);

//     const submit = () => {
//         if (name && email && message) {
//             const serviceId = 'service_3qpfid9';
//             const templateId = 'template_rjgg6ov';
//             const userId = 'user_fU6XptlMrUiVyXLFp9xLx';
//             const templateParams = {
//                 name,
//                 email,
//                 message
//             };

//             emailjs.send(serviceId, templateId, templateParams, userId)
//                 .then(response => console.log(response))
//                 .then(error => console.log(error));

//             setName('');
//             setEmail('');
//             setMessage('');
//             setEmailSent(true);
//         } else {
//             alert('Please fill in all fields.');
//         }
//     };

//     const isValidEmail = email => {
//         const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//         return regex.test(String(email).toLowerCase());
//     };
//     return (
//         <section className="container contact-us-container">
//             <div className="row justify-content-center">
//                 <div className="col-sm-12 mb-4 col-md-6">
//                     <div className="card rounded-0">
//                         <div className="card-header p-0">
//                             <div className="card-header text-white text-center py-2">
//                                 <h3><i className="fa fa-envelope"></i> GET IN TOUCH</h3>
//                                 <p className="m-0">I'd love to hear from you!</p>
//                             </div>
//                         </div>
//                         <div className="card-body p-3">

//                             <div className="form-group">
//                                 <div className="input-group">
//                                     <input type="text" name="data[name]" className="form-control" id="inlineFormInputGroupUsername" placeholder="Your name" value={name} onChange={e => setName(e.target.value)} />
//                                 </div>
//                             </div>
//                             <div className="form-group mt-2">
//                                 <div className="input-group mb-2 mb-sm-0">
//                                     <input type="email" name="data[email]" className="form-control" id="inlineFormInputGroupUsername" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
//                                 </div>
//                             </div>
//                             <div className="form-group mt-2">
//                                 <div className="input-group mb-2 mb-sm-0">
//                                     <textarea className="form-control" name="" id="" cols="30" rows="5" placeholder="Message"></textarea>
//                                 </div>
//                             </div>
//                             <Button text="Send" onClick={submit} />
//                             <span className={emailSent ? 'visible' : null}>Thank you for your message, we will be in touch in no time!</span>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </section>

//         // <div id="contact-form">
//         //     <input type="text" placeholder="Your Name" value={name} onChange={e => setName(e.target.value)} />
//         //     <input type="email" placeholder="Your email address" value={email} onChange={e => setEmail(e.target.value)} />
//         //     <textarea placeholder="Your message" value={message} onChange={e => setMessage(e.target.value)}></textarea>
//         //     <button onClick={submit}>Send Message</button>
//         //     <span classNameName={emailSent ? 'visible' : null}>Thank you for your message, we will be in touch in no time!</span>
//         // </div>
//     );
// };

// export default ContactForm;